// extracted by mini-css-extract-plugin
export default {"product_container":"ProductsAds_product_container__ybwbw","product_image_":"ProductsAds_product_image___reTft"};